import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="user-role-form"
export default class extends Controller {
  static targets = ["roleSelect", "emailField", "passwordField", "languageField", "photoField"]
  static values = { 
    mdlRole: String
  }

  connect() {
    this.checkRole()
  }

  roleChanged() {
    this.checkRole()
  }

  checkRole() {
    const selectedRole = this.roleSelectTarget.value
    const isMdl = selectedRole === this.mdlRoleValue

    if (isMdl) {
      this.hideFieldsForMdl()
    } else {
      this.showAllFields()
    }
  }

  hideFieldsForMdl() {
    // Скрываем поля email, пароль, язык (фото оставляем видимым для моделей)
    this.hideField(this.emailFieldTarget)
    this.hideField(this.passwordFieldTarget) 
    this.hideField(this.languageFieldTarget)
    // Фото остается видимым для моделей
    this.showField(this.photoFieldTarget)
  }

  showAllFields() {
    // Показываем все поля
    this.showField(this.emailFieldTarget)
    this.showField(this.passwordFieldTarget)
    this.showField(this.languageFieldTarget)
    this.showField(this.photoFieldTarget)
  }

  hideField(fieldContainer) {
    fieldContainer.style.display = 'none'
    // Убираем required атрибуты для скрытых полей
    const inputs = fieldContainer.querySelectorAll('input, select')
    inputs.forEach(input => {
      if (input.hasAttribute('required')) {
        input.dataset.wasRequired = 'true'
        input.removeAttribute('required')
      }
    })
  }

  showField(fieldContainer) {
    fieldContainer.style.display = ''
    // Возвращаем required атрибуты
    const inputs = fieldContainer.querySelectorAll('input, select')
    inputs.forEach(input => {
      if (input.dataset.wasRequired === 'true' || input.dataset.required === 'true') {
        input.setAttribute('required', 'required')
      }
    })
  }
}
